import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Link } from "react-router-dom";

const Success = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: "100vh",
      }}
    >
      <div style={{ marginTop: "25vh", textAlign: "center", padding: "20px" }}>
        <CheckCircleOutlineIcon
          style={{ fontSize: "80px", color: "#4CAF50", marginBottom: "10px" }}
        />
        <Typography variant="h5" style={{ marginBottom: "10px" }}>
          Payment Successful!
        </Typography>
        <Typography variant="body1" style={{ marginBottom: "20px" }}>
          Thank you for your payment. Your transaction has been completed
          successfully.
        </Typography>
        <Link to="/user/dashboard">
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "20px" }}
          >
            Go to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Success;
